import { Outlet } from 'react-router-dom';
import { Header } from '@/widgets/header/Header';
import { Footer } from '@/widgets/footer/Footer';
import { SubscriptionBanner } from '@/features/subscription/SubscriptionBanner';
import { SubscriptionBlockedModal } from '@/features/subscription/SubscriptionBlockedModal';

export function AppLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SubscriptionBanner />
      <Header />
      <main id="main" className="flex-1 min-w-0">
        <Outlet />
      </main>
      <Footer />
      <SubscriptionBlockedModal />
    </div>
  );
}
